import { AddSnackPayload, NotificationsStateType, Snack } from './notificationsSlice.types'
import { AnalyticsWelcomeToastProps } from '../../../components/AnalyticsWelcomeToast/types'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: NotificationsStateType = {
  snacks: [],
  isOpen: false,
  currentSnack: undefined,
  analyticsWelcomeToast: {
    isOpen: false
  }
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload
    },

    addSnack: (state, action: PayloadAction<AddSnackPayload>) => {
      const snack = { ...action.payload, key: new Date().getTime() }
      state.snacks = [...state.snacks, snack]
    },

    setSnacks: (state, action: PayloadAction<Snack[]>) => {
      state.snacks = action.payload
    },

    setCurrentSnack: (state, action: PayloadAction<Snack | undefined>) => {
      state.currentSnack = action.payload
    },

    setAnalyticsWelcomeToastProps: (
      state,
      action: PayloadAction<AnalyticsWelcomeToastProps | undefined>
    ) => {
      state.analyticsWelcomeToast.props = action.payload
    },

    setAnalyticsWelcomeToastOpen: (state, action: PayloadAction<boolean>) => {
      state.analyticsWelcomeToast = {
        ...state.analyticsWelcomeToast,
        isOpen: action.payload
      }
    }
  }
})

export const {
  setOpen,
  addSnack,
  setCurrentSnack,
  setSnacks,
  setAnalyticsWelcomeToastProps,
  setAnalyticsWelcomeToastOpen
} = notificationsSlice.actions

export default notificationsSlice.reducer
